import { Injectable } from '@angular/core';
import { ServicoAutenticacao } from '../core/auth/servico-autenticacao';
import { ServicoTenant } from '../core/tenant/servico-tenant';

export type AcaoInicializacaoShell = 'terminal-publico' | 'sessao-token' | 'login-tenant';

@Injectable({ providedIn: 'root' })
export class ServicoInicializacaoShell {
  constructor(
    private readonly servicoAutenticacao: ServicoAutenticacao,
    private readonly servicoTenant: ServicoTenant
  ) {}

  acaoInicial() {
    if (this.servicoTenant.ehRotaTerminalPublico()) {
      return 'terminal-publico';
    }

    return this.servicoAutenticacao.possuiToken ? 'sessao-token' : 'login-tenant';
  }
}
